import axios from "axios";

export var http = axios.create({
  withCredentials: false,
  baseURL: "https://machado.sagatecbrasil.com.br/",
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/x-www-form-urlencoded",
  },
});
